import { GET_COMMENTS } from '../Actions/types';
import initialState from './initial-state';

export default function(state = initialState.comments, action) {
  switch (action.type) {
    
    case GET_COMMENTS:
      return action.payload;

    default:
      return state;
  }
}


// WEBPACK FOOTER //
// ./src/reducers/commentsReducer.js